if (!customElements.get('image-slider')) {
  class ImageSlider extends HTMLElement {
    selectors = {
      arrows: {
        arrowLeft: '[image-slider="controls"] .arrow-left',
        arrowRight: '[image-slider="controls"] .arrow-right',
      },
      slider: '.swiper',
    };

    constructor() {
      super();
    }

    connectedCallback() {
      this.elements = {
        arrows: {
          arrowLeft: this.closest('section').querySelector(
            this.selectors.arrows.arrowLeft,
          ),
          arrowRight: this.closest('section').querySelector(
            this.selectors.arrows.arrowRight,
          ),
        },
        slider: this.querySelector(this.selectors.slider),
      };

      this.settings = {
        slidesPerView: 'auto',
        navigation: {
          prevEl: this.elements.arrows.arrowLeft,
          nextEl: this.elements.arrows.arrowRight,
        },
        breakpoints: {
          240: {
            centeredSlides: true,
            initialSlide: 1,
          },
          768: {
            centeredSlides: false,
            initialSlide: 0,
          },
        },
      };

      this.slider = new Swiper(this.elements.slider, this.settings);

      if (Shopify.designMode) {
        this.addEventListener(
          'shopify:block:select',
          this.handleBlockSelect.bind(this),
        );
      }
    }

    /**
     * Handle Shopify admin section block select.
     * @param {Object} e Event
     */
    handleBlockSelect(e) {
      const targetIndex = Number(e.target?.getAttribute('data-slide-index'));

      if (!Number.isNaN(targetIndex)) {
        this.slider.slideTo(targetIndex);
      }
    }
  }
  customElements.define('image-slider', ImageSlider);
}
